const getDomain = () => {
  const { hostname } = window.location
  return hostname.toLowerCase().includes('foregon.com')
    ? 'foregon.com'
    : hostname
}

const cookie = {
  set: (
    name,
    value,
    seconds = 365 * 24 * 60 * 60,
    path = '/',
    domain = getDomain()
  ) => {
    const expires = new Date(Date.now() + seconds * 1000).toUTCString()

    document.cookie = `${name}=${value};${
      expires ? ` expires=${expires};` : ''
    } domain=${domain}; path=${path}`
  },

  get: (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop().split(';').shift()
    }

    return null
  },

  delete: (name, domain = getDomain()) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/;`
  },
}

export default cookie
